import React, { useEffect, useState, type Dispatch, type SetStateAction } from 'react'

interface OTPTimerProps {
    timer?: number, // in seconds
    setTimeExpired?: Dispatch<SetStateAction<boolean>>
}
const OTPTimer = ({ timer, setTimeExpired }: OTPTimerProps) => {
    const [timeLeft, setTimeLeft] = useState(timer ? timer : 60);

    useEffect(() => {
        if (timeLeft <= 0) {
            if (setTimeExpired) setTimeExpired(true)

            return
        }
        const interval = setInterval(() => {
            setTimeLeft((prev) => prev - 1)
        }, 1000)
        return () => clearInterval(interval)
    }, [setTimeExpired, timeLeft])

    const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0')
    const seconds = (timeLeft % 60).toString().padStart(2, '0')
    return (
        <>
            You can request a new code in <span className="text-[#16111] font-[700]" >{minutes}:{seconds}</span>
        </>
    )
}

export default OTPTimer